const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
] as const;

export type UtmParams = Record<(typeof UTM_KEYS)[number], string>;

const STORAGE_KEY = 'pixelpro-utm';

const emptyUtm = (): UtmParams => ({
  utm_source: '',
  utm_medium: '',
  utm_campaign: '',
  utm_content: '',
  utm_term: '',
});

export const readUtmFromSession = (): UtmParams => {
  if (typeof window === 'undefined') return emptyUtm();
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return emptyUtm();
    const parsed = JSON.parse(raw) as Partial<UtmParams>;
    return { ...emptyUtm(), ...parsed };
  } catch {
    return emptyUtm();
  }
};

export const persistUtmFromSearch = (search: string): UtmParams => {
  if (typeof window === 'undefined') return emptyUtm();
  const params = new URLSearchParams(search);
  const existing = readUtmFromSession();
  const next = { ...existing };

  let hasAny = false;
  UTM_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) {
      next[key] = value;
      hasAny = true;
    }
  });

  if (hasAny) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  }

  return next;
};
